// src/ui/recusarComMotivo.js
// Modal para o gestor recusar uma sugestao informando o MOTIVO (a recepcao ve depois,
// para saber onde melhorar). O motivo e opcional, mas incentivado.
import { el } from '../lib/dom.js';
import { abrirModal } from './modal.js';

/** @param {(motivo:string)=>Promise<boolean>} aoRecusar  retorne true em sucesso; false mantem aberto. */
export function recusarComMotivo(aoRecusar) {
  const ta = el('textarea', { rows: '3', placeholder: 'Ex.: já existe um igual / nome genérico demais / não é um setor real…' });
  abrirModal({
    titulo: 'Recusar sugestão',
    corpo: [
      el('p', { class: 'view__sub', style: 'margin-top:0', text: 'Diga o motivo — quem sugeriu verá esta resposta para saber como melhorar (opcional, mas ajuda muito).' }),
      el('div', { class: 'campo' }, [el('label', { text: 'Motivo da recusa' }), ta]),
    ],
    acoes: [
      { rotulo: 'Cancelar', classe: 'btn' },
      { rotulo: 'Recusar', classe: 'btn btn--perigo', onClick: async () => await aoRecusar((ta.value || '').trim()) },
    ],
  });
}